module.exports = __webpack_public_path__ + "img/historia15.fa25a97f.jpg";